
import ReviewCarousel from "@/components/carousel/ReviewCarousel.vue";
export default {
  components: {
    ReviewCarousel
  },
  props: {
    screenW: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      icons: [
        {
          name: "safe",
          img: require('~/assets/img/svg/safe_white.svg'),
          imgDesc: 'Brand Safe',
          title: 'partners_page.icons.safe.title',
          description: 'partners_page.icons.safe.description',
        },
        {
          name: "view",
          img: require('~/assets/img/png/viewability.png'),
          imgDesc: 'Top Viewability',
          title: 'partners_page.icons.view.title',
          description: 'partners_page.icons.view.description',
        },
        {
          name: "humans",
          img: require('~/assets/img/png/human.png'),
          imgDesc: 'Real Humans',
          title: 'partners_page.icons.humans.title',
          description: 'partners_page.icons.humans.description',
        },
        {
          name: "stream",
          img: require('~/assets/img/png/in-stream.png'),
          imgDesc: 'In-stream ads',
          title: 'partners_page.icons.stream.title',
          description: 'partners_page.icons.stream.description',
        },
        {
          name: "sound",
          img: require('~/assets/img/png/sound_on.png'),
          imgDesc: 'Sound on',
          title: 'partners_page.icons.sound.title',
          description: 'partners_page.icons.sound.description',
        },
        {
          name: "skip",
          img: require('~/assets/img/png/unskippable.png'),
          imgDesc: 'Unskippable',
          title: 'partners_page.icons.skip.title',
          description: 'partners_page.icons.skip.description',
        },
      ]
    }
  }
}
